(function () {
  function run() {
    // F1: focusable gift-note button inside an aria-hidden wrapper
    document.querySelectorAll(
      '.cart__footer-order-note-wrapper[aria-hidden],.quick-cart__footer-order-note-wrapper[aria-hidden]'
    ).forEach(function (w) { w.removeAttribute('aria-hidden'); });

    // F4 + F6: duplicate IDs (price filter, quantity inputs, CartSpecialInstructions)
    var seen = {}, n = 0;
    document.querySelectorAll('[id]').forEach(function (el) {
      var id = el.id;
      if (!seen[id]) { seen[id] = 1; return; }
      var newId = id + '--a11y' + (++n);
      var scope = el.closest('label, li, .cart__form-item, .filter-item, form') || document;
      scope.querySelectorAll('[for="' + id.replace(/"/g, '\\"') + '"]')
        .forEach(function (l) { l.setAttribute('for', newId); });
      el.id = newId;
    });

    // F8: name each filter group for assistive tech
    document.querySelectorAll('button[aria-controls]').forEach(function (btn) {
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel || !panel.querySelector('input')) return;
      if (!btn.id) btn.id = 'a11y-grp-' + (btn.getAttribute('aria-controls') || '').replace(/\W/g, '');
      panel.setAttribute('role', 'group');
      panel.setAttribute('aria-labelledby', btn.id);
    });

    // F7: live region for cart total changes
    if (!document.getElementById('a11y-cart-status')) {
      var p = document.createElement('p');
      p.id = 'a11y-cart-status';
      p.className = 'visually-hidden';
      p.setAttribute('role', 'status');
      p.setAttribute('aria-live', 'polite');
      p.setAttribute('aria-atomic', 'true');
      document.body.appendChild(p);
    }
  }

  // Minor cluster from the June audit, verified still live 2026-08-26.
  function minorCluster() {
    // 1.3.5 Identify Input Purpose: the newsletter/footer email fields carry no
    // autocomplete token. (The search field `q` is deliberately skipped -- 1.3.5
    // covers fields collecting data ABOUT THE USER, and there is no valid
    // input-purpose token for a site search box.)
    document.querySelectorAll('input[type="email"], input[name="contact[email]"]')
      .forEach(function (i) {
        if (!i.getAttribute('autocomplete')) i.setAttribute('autocomplete', 'email');
      });

    // 2.4.4 / 4.1.2: the footer social links are icon-only with no accessible name,
    // so they read as bare "link". Name them from their destination.
    var SOCIAL = {
      'facebook.com': 'Gooselings on Facebook',
      'instagram.com': 'Gooselings on Instagram',
      'pinterest.com': 'Gooselings on Pinterest',
      'tiktok.com': 'Gooselings on TikTok',
      'twitter.com': 'Gooselings on Twitter',
      'x.com': 'Gooselings on X',
      'youtube.com': 'Gooselings on YouTube'
    };
    document.querySelectorAll('a[href]').forEach(function (a) {
      if (a.getAttribute('aria-label') || a.textContent.trim()) return;
      var href = a.getAttribute('href') || '';
      Object.keys(SOCIAL).forEach(function (host) {
        if (href.indexOf(host) !== -1) a.setAttribute('aria-label', SOCIAL[host]);
      });
    });

    // 1.3.1 / 2.4.1: multiple <nav> landmarks with no distinct accessible names.
    // A landmark is named by aria-label/aria-labelledby only -- its text content
    // does not name it -- so all of these were reading as plain "navigation".
    [['.header__links-primary', 'Main'],
     ['.header__links-secondary', 'Secondary'],
     ['.drawer-menu__main', 'Mobile'],
     ['.footer__nav, .footer nav', 'Footer']].forEach(function (pair) {
      document.querySelectorAll(pair[0]).forEach(function (n) {
        if (!n.getAttribute('aria-label') && !n.getAttribute('aria-labelledby')) {
          n.setAttribute('aria-label', pair[1]);
        }
      });
    });
    document.querySelectorAll('nav').forEach(function (n) {
      if (!n.getAttribute('aria-label') && !n.getAttribute('aria-labelledby')) {
        n.setAttribute('aria-label', 'Navigation');
      }
    });
  }

  function strings() {
    var s = (window.theme && window.theme.strings && window.theme.strings.accessibility) || {};
    return { play: s.play_video || 'Play', pause: s.pause_video || 'Pause' };
  }

  // F11 (2.2.2): the hero pause button existed but did not work. The theme rebinds it
  // in _playVideo() every time the video template is swapped and never releases the
  // previous listener, so a single click ran pause AND play back-to-back -- verified
  // live: one click fired the 'pause' then 'play' events and the video kept playing,
  // while the label flipped to "Play". Claim the click during the capture phase so the
  // stacked theme handlers (bound directly on the button) never receive it.
  function ownVideoPauseButtons() {
    if (document.documentElement.hasAttribute('data-a11y-video-pause')) return;
    document.documentElement.setAttribute('data-a11y-video-pause', '');

    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest && e.target.closest('.video-pause');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();

      var scope = btn.closest('.video-with-text__video-wrapper, .video-hero__video-wrapper')
        || btn.parentNode || document;
      var v = scope.querySelector('video') || document.querySelector('video');
      if (!v) return;

      var t = strings();
      if (v.paused) {
        v.play();
        btn.textContent = t.pause;
        btn.setAttribute('aria-pressed', 'false');
      } else {
        v.pause();
        btn.textContent = t.play;
        btn.setAttribute('aria-pressed', 'true');
      }
    }, true);
  }

  // F9 (4.1.3 / 4.1.2): the newsletter flyout is non-modal and never receives focus --
  // showPopup() only calls focusTrap.activate() for popupType "popup"/"age" -- so its
  // appearance was announced to nobody. Name it, and announce it when .visible lands.
  function announcePopups() {
    var popups = document.querySelectorAll('[data-popup]');
    if (!popups.length) return;

    var status = document.getElementById('a11y-popup-status');
    if (!status) {
      status = document.createElement('p');
      status.id = 'a11y-popup-status';
      status.className = 'visually-hidden';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      status.setAttribute('aria-atomic', 'true');
      document.body.appendChild(status);
    }

    popups.forEach(function (popup) {
      if (!popup.getAttribute('role')) popup.setAttribute('role', 'region');
      if (!popup.getAttribute('aria-label')) {
        var h = popup.querySelector('.popup__heading, h2, h3');
        popup.setAttribute('aria-label',
          (h && h.textContent.replace(/\s+/g, ' ').trim()) || 'Newsletter');
      }
      if (popup.hasAttribute('data-a11y-watched')) return;
      popup.setAttribute('data-a11y-watched', '');

      // Modal popups move focus on open, which already announces them. Only the
      // silent non-modal flyout needs a spoken cue.
      if (popup.getAttribute('data-popup-type') === 'popup'
        || popup.getAttribute('data-popup-type') === 'age') return;

      var wasVisible = popup.classList.contains('visible');
      new MutationObserver(function () {
        var isVisible = popup.classList.contains('visible');
        if (isVisible === wasVisible) return;
        wasVisible = isVisible;
        if (isVisible) status.textContent = popup.getAttribute('aria-label') + ' dialog opened.';
      }).observe(popup, { attributes: true, attributeFilter: ['class'] });
    });
  }

  function boot() {
    run();
    minorCluster();
    ownVideoPauseButtons();
    announcePopups();
    var status = document.getElementById('a11y-cart-status');
    var el = document.querySelector('.cart__footer-subtotal,.quick-cart__footer-subtotal');
    var last = el ? el.textContent.replace(/\s+/g, ' ').trim() : '';  // prime silently, no announcement on load

    new MutationObserver(function () {
      run();
      minorCluster();
      announcePopups();
      var s = document.querySelector('.cart__footer-subtotal,.quick-cart__footer-subtotal');
      if (!s) return;
      var t = s.textContent.replace(/\s+/g, ' ').trim();
      if (t && t !== last) { last = t; status.textContent = 'Cart updated. ' + t; }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', boot)
    : boot();
})();